import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { IMailingAddress } from "@utils/interfaces";

interface IAmountRange {
  minimumAmountRange: number;
  maximumAmountRange: number;
}

interface ISurrenderObject {
  year: number;
  amount: number;
}
interface ISqsquotation {
  maturityPayout: number;
  surrenderValueList: ISurrenderObject[];
  surrenderValue: number;
  deathBenefit: number;
}
interface IQuotation {
  sqsquotation: ISqsquotation;
  investingAmount: number;
}

interface IStaticData {
  productName: string;
  premiumTerm: string;
  policyTerm: string;
  interestRate: string;
  returnRate: string;
  singlifeBankNumber: string;
  singlifePayeeAccount: string;
  countryList: Array<{id:string, label:string}>
}

interface IPlanData {
  planoverview: Array<{
    heading: { text: string };
    descriptions: Array<{ text: string; value: string }>;
  }>;
  summary: { text: string; value: string };
}
interface IinitialState {
  staticData: IStaticData;
  amountRangeSlider: IAmountRange;
  transactionId: null | string;
  singpassInitiatedOrManual: "SINGPASS"|"MANUAL"|null,
  quotation: IQuotation;
  AgreedInitialTerms: boolean | null;
  PlanData: IPlanData | null;
  TrenchesLimit: boolean;
}

const initialState: IinitialState = {
  staticData: {
    productName: "Digital Secure Saver",
    premiumTerm: "",
    policyTerm: "",
    interestRate: "",
    returnRate: "",
    countryList:  [
      {
          "id": "AX",
          "label": "Aland Islands"
      },
      {
          "id": "AL",
          "label": "Albania"
      },
      {
          "id": "DZ",
          "label": "Algeria"
      },
      {
          "id": "AD",
          "label": "Andorra"
      },
      {
          "id": "AO",
          "label": "Angola"
      },
      {
          "id": "AI",
          "label": "Anguilla"
      },
      {
          "id": "AQ",
          "label": "Antarctica"
      },
      {
          "id": "AG",
          "label": "Antigua and Barbuda"
      },
      {
          "id": "AR",
          "label": "Argentina"
      },
      {
          "id": "AM",
          "label": "Armenia"
      },
      {
          "id": "AW",
          "label": "Aruba"
      },
      {
          "id": "AU",
          "label": "Australia"
      },
      {
          "id": "AT",
          "label": "Austria"
      },
      {
          "id": "AZ",
          "label": "Azerbaijan"
      },
      {
          "id": "BS",
          "label": "Bahamas"
      },
      {
          "id": "BH",
          "label": "Bahrain"
      },
      {
          "id": "BD",
          "label": "Bangladesh"
      },
      {
          "id": "BB",
          "label": "Barbados"
      },
      {
          "id": "BY",
          "label": "Belarus"
      },
      {
          "id": "BE",
          "label": "Belgium"
      },
      {
          "id": "BZ",
          "label": "Belize"
      },
      {
          "id": "BJ",
          "label": "Benin"
      },
      {
          "id": "BM",
          "label": "Bermuda"
      },
      {
          "id": "BT",
          "label": "Bhutan"
      },
      {
          "id": "BO",
          "label": "Bolivia"
      },
      {
          "id": "BQ",
          "label": "Bonaire, Sint Eustatius and Saba"
      },
      {
          "id": "BA",
          "label": "Bosnia and Herzegovina"
      },
      {
          "id": "BW",
          "label": "Botswana"
      },
      {
          "id": "BV",
          "label": "Bouvet Island"
      },
      {
          "id": "BR",
          "label": "Brazil"
      },
      {
          "id": "IO",
          "label": "British Indian Ocean Territory"
      },
      {
          "id": "BN",
          "label": "Brunei Darussalam"
      },
      {
          "id": "BG",
          "label": "Bulgaria"
      },
      {
          "id": "BF",
          "label": "Burkina Faso"
      },
      {
          "id": "BI",
          "label": "Burundi"
      },
      {
          "id": "KH",
          "label": "Cambodia"
      },
      {
          "id": "CM",
          "label": "Cameroon"
      },
      {
          "id": "CA",
          "label": "Canada"
      },
      {
          "id": "CV",
          "label": "Cape Verde"
      },
      {
          "id": "KY",
          "label": "Cayman Islands"
      },
      {
          "id": "CF",
          "label": "Central African Republic"
      },
      {
          "id": "TD",
          "label": "Chad"
      },
      {
          "id": "CL",
          "label": "Chile"
      },
      {
          "id": "CN",
          "label": "China"
      },
      {
          "id": "CX",
          "label": "Christmas Island"
      },
      {
          "id": "CC",
          "label": "Cocos (Keeling) Islands"
      },
      {
          "id": "CO",
          "label": "Colombia"
      },
      {
          "id": "KM",
          "label": "Comoros"
      },
      {
          "id": "CG",
          "label": "Congo"
      },
      {
          "id": "CD",
          "label": "Congo, Democratic Republic of the Congo"
      },
      {
          "id": "CK",
          "label": "Cook Islands"
      },
      {
          "id": "CR",
          "label": "Costa Rica"
      },
      {
          "id": "CI",
          "label": "Cote D'Ivoire"
      },
      {
          "id": "HR",
          "label": "Croatia"
      },
      {
          "id": "CU",
          "label": "Cuba"
      },
      {
          "id": "CW",
          "label": "Curacao"
      },
      {
          "id": "CY",
          "label": "Cyprus"
      },
      {
          "id": "CZ",
          "label": "Czech Republic"
      },
      {
          "id": "DK",
          "label": "Denmark"
      },
      {
          "id": "DJ",
          "label": "Djibouti"
      },
      {
          "id": "DM",
          "label": "Dominica"
      },
      {
          "id": "DO",
          "label": "Dominican Republic"
      },
      {
          "id": "EC",
          "label": "Ecuador"
      },
      {
          "id": "EG",
          "label": "Egypt"
      },
      {
          "id": "SV",
          "label": "El Salvador"
      },
      {
          "id": "GQ",
          "label": "Equatorial Guinea"
      },
      {
          "id": "ER",
          "label": "Eritrea"
      },
      {
          "id": "EE",
          "label": "Estonia"
      },
      {
          "id": "ET",
          "label": "Ethiopia"
      },
      {
          "id": "FK",
          "label": "Falkland Islands (Malvinas)"
      },
      {
          "id": "FO",
          "label": "Faroe Islands"
      },
      {
          "id": "FJ",
          "label": "Fiji"
      },
      {
          "id": "FI",
          "label": "Finland"
      },
      {
          "id": "FR",
          "label": "France"
      },
      {
          "id": "GF",
          "label": "French Guiana"
      },
      {
          "id": "PF",
          "label": "French Polynesia"
      },
      {
          "id": "TF",
          "label": "French Southern Territories"
      },
      {
          "id": "GA",
          "label": "Gabon"
      },
      {
          "id": "GM",
          "label": "Gambia"
      },
      {
          "id": "GE",
          "label": "Georgia"
      },
      {
          "id": "DE",
          "label": "Germany"
      },
      {
          "id": "GH",
          "label": "Ghana"
      },
      {
          "id": "GI",
          "label": "Gibraltar"
      },
      {
          "id": "GR",
          "label": "Greece"
      },
      {
          "id": "GL",
          "label": "Greenland"
      },
      {
          "id": "GD",
          "label": "Grenada"
      },
      {
          "id": "GP",
          "label": "Guadeloupe"
      },
      {
          "id": "GU",
          "label": "Guam"
      },
      {
          "id": "GT",
          "label": "Guatemala"
      },
      {
          "id": "GG",
          "label": "Guernsey"
      },
      {
          "id": "GN",
          "label": "Guinea"
      },
      {
          "id": "GW",
          "label": "Guinea-Bissau"
      },
      {
          "id": "GY",
          "label": "Guyana"
      },
      {
          "id": "HT",
          "label": "Haiti"
      },
      {
          "id": "HM",
          "label": "Heard Island and Mcdonald Islands"
      },
      {
          "id": "VA",
          "label": "Holy See (Vatican City State)"
      },
      {
          "id": "HN",
          "label": "Honduras"
      },
      {
          "id": "HK",
          "label": "Hong Kong"
      },
      {
          "id": "HU",
          "label": "Hungary"
      },
      {
          "id": "IS",
          "label": "Iceland"
      },
      {
          "id": "IN",
          "label": "India"
      },
      {
          "id": "ID",
          "label": "Indonesia"
      },
      {
          "id": "IR",
          "label": "Iran, Islamic Republic of"
      },
      {
          "id": "IQ",
          "label": "Iraq"
      },
      {
          "id": "IE",
          "label": "Ireland"
      },
      {
          "id": "IM",
          "label": "Isle of Man"
      },
      {
          "id": "IL",
          "label": "Israel"
      },
      {
          "id": "IT",
          "label": "Italy"
      },
      {
          "id": "JM",
          "label": "Jamaica"
      },
      {
          "id": "JP",
          "label": "Japan"
      },
      {
          "id": "JE",
          "label": "Jersey"
      },
      {
          "id": "JO",
          "label": "Jordan"
      },
      {
          "id": "KZ",
          "label": "Kazakhstan"
      },
      {
          "id": "KE",
          "label": "Kenya"
      },
      {
          "id": "KI",
          "label": "Kiribati"
      },
      {
          "id": "KP",
          "label": "Korea, Democratic People's Republic of"
      },
      {
          "id": "KR",
          "label": "Korea, Republic of"
      },
      {
          "id": "XK",
          "label": "Kosovo"
      },
      {
          "id": "KW",
          "label": "Kuwait"
      },
      {
          "id": "KG",
          "label": "Kyrgyzstan"
      },
      {
          "id": "LA",
          "label": "Lao People's Democratic Republic"
      },
      {
          "id": "LV",
          "label": "Latvia"
      },
      {
          "id": "LB",
          "label": "Lebanon"
      },
      {
          "id": "LS",
          "label": "Lesotho"
      },
      {
          "id": "LR",
          "label": "Liberia"
      },
      {
          "id": "LY",
          "label": "Libyan Arab Jamahiriya"
      },
      {
          "id": "LI",
          "label": "Liechtenstein"
      },
      {
          "id": "LT",
          "label": "Lithuania"
      },
      {
          "id": "LU",
          "label": "Luxembourg"
      },
      {
          "id": "MO",
          "label": "Macao"
      },
      {
          "id": "MK",
          "label": "Macedonia, the Former Yugoslav Republic of"
      },
      {
          "id": "MG",
          "label": "Madagascar"
      },
      {
          "id": "MW",
          "label": "Malawi"
      },
      {
          "id": "MY",
          "label": "Malaysia"
      },
      {
          "id": "MV",
          "label": "Maldives"
      },
      {
          "id": "ML",
          "label": "Mali"
      },
      {
          "id": "MT",
          "label": "Malta"
      },
      {
          "id": "MH",
          "label": "Marshall Islands"
      },
      {
          "id": "MQ",
          "label": "Martinique"
      },
      {
          "id": "MR",
          "label": "Mauritania"
      },
      {
          "id": "MU",
          "label": "Mauritius"
      },
      {
          "id": "YT",
          "label": "Mayotte"
      },
      {
          "id": "MX",
          "label": "Mexico"
      },
      {
          "id": "FM",
          "label": "Micronesia, Federated States of"
      },
      {
          "id": "MD",
          "label": "Moldova, Republic of"
      },
      {
          "id": "MC",
          "label": "Monaco"
      },
      {
          "id": "MN",
          "label": "Mongolia"
      },
      {
          "id": "ME",
          "label": "Montenegro"
      },
      {
          "id": "MS",
          "label": "Montserrat"
      },
      {
          "id": "MA",
          "label": "Morocco"
      },
      {
          "id": "MZ",
          "label": "Mozambique"
      },
      {
          "id": "MM",
          "label": "Myanmar"
      },
      {
          "id": "NA",
          "label": "Namibia"
      },
      {
          "id": "NR",
          "label": "Nauru"
      },
      {
          "id": "NP",
          "label": "Nepal"
      },
      {
          "id": "NL",
          "label": "Netherlands"
      },
      {
          "id": "AN",
          "label": "Netherlands Antilles"
      },
      {
          "id": "NC",
          "label": "New Caledonia"
      },
      {
          "id": "NZ",
          "label": "New Zealand"
      },
      {
          "id": "NI",
          "label": "Nicaragua"
      },
      {
          "id": "NE",
          "label": "Niger"
      },
      {
          "id": "NG",
          "label": "Nigeria"
      },
      {
          "id": "NU",
          "label": "Niue"
      },
      {
          "id": "NF",
          "label": "Norfolk Island"
      },
      {
          "id": "MP",
          "label": "Northern Mariana Islands"
      },
      {
          "id": "NO",
          "label": "Norway"
      },
      {
          "id": "OM",
          "label": "Oman"
      },
      {
          "id": "PK",
          "label": "Pakistan"
      },
      {
          "id": "PW",
          "label": "Palau"
      },
      {
          "id": "PS",
          "label": "Palestinian Territory, Occupied"
      },
      {
          "id": "PA",
          "label": "Panama"
      },
      {
          "id": "PG",
          "label": "Papua New Guinea"
      },
      {
          "id": "PY",
          "label": "Paraguay"
      },
      {
          "id": "PE",
          "label": "Peru"
      },
      {
          "id": "PH",
          "label": "Philippines"
      },
      {
          "id": "PN",
          "label": "Pitcairn"
      },
      {
          "id": "PL",
          "label": "Poland"
      },
      {
          "id": "PT",
          "label": "Portugal"
      },
      {
          "id": "PR",
          "label": "Puerto Rico"
      },
      {
          "id": "QA",
          "label": "Qatar"
      },
      {
          "id": "RE",
          "label": "Reunion"
      },
      {
          "id": "RO",
          "label": "Romania"
      },
      {
          "id": "RU",
          "label": "Russian Federation"
      },
      {
          "id": "RW",
          "label": "Rwanda"
      },
      {
          "id": "BL",
          "label": "Saint Barthelemy"
      },
      {
          "id": "SH",
          "label": "Saint Helena"
      },
      {
          "id": "KN",
          "label": "Saint Kitts and Nevis"
      },
      {
          "id": "LC",
          "label": "Saint Lucia"
      },
      {
          "id": "MF",
          "label": "Saint Martin"
      },
      {
          "id": "PM",
          "label": "Saint Pierre and Miquelon"
      },
      {
          "id": "VC",
          "label": "Saint Vincent and the Grenadines"
      },
      {
          "id": "WS",
          "label": "Samoa"
      },
      {
          "id": "SM",
          "label": "San Marino"
      },
      {
          "id": "ST",
          "label": "Sao Tome and Principe"
      },
      {
          "id": "SA",
          "label": "Saudi Arabia"
      },
      {
          "id": "SN",
          "label": "Senegal"
      },
      {
          "id": "RS",
          "label": "Serbia"
      },
      {
          "id": "CS",
          "label": "Serbia and Montenegro"
      },
      {
          "id": "SC",
          "label": "Seychelles"
      },
      {
          "id": "SL",
          "label": "Sierra Leone"
      },
      {
          "id": "SG",
          "label": "Singapore"
      },
      {
          "id": "SX",
          "label": "Sint Maarten"
      },
      {
          "id": "SK",
          "label": "Slovakia"
      },
      {
          "id": "SI",
          "label": "Slovenia"
      },
      {
          "id": "SB",
          "label": "Solomon Islands"
      },
      {
          "id": "SO",
          "label": "Somalia"
      },
      {
          "id": "ZA",
          "label": "South Africa"
      },
      {
          "id": "GS",
          "label": "South Georgia and the South Sandwich Islands"
      },
      {
          "id": "SS",
          "label": "South Sudan"
      },
      {
          "id": "ES",
          "label": "Spain"
      },
      {
          "id": "LK",
          "label": "Sri Lanka"
      },
      {
          "id": "SD",
          "label": "Sudan"
      },
      {
          "id": "SR",
          "label": "Suriname"
      },
      {
          "id": "SJ",
          "label": "Svalbard and Jan Mayen"
      },
      {
          "id": "SZ",
          "label": "Swaziland"
      },
      {
          "id": "SE",
          "label": "Sweden"
      },
      {
          "id": "CH",
          "label": "Switzerland"
      },
      {
          "id": "SY",
          "label": "Syrian Arab Republic"
      },
      {
          "id": "TW",
          "label": "Taiwan, Province of China"
      },
      {
          "id": "TJ",
          "label": "Tajikistan"
      },
      {
          "id": "TZ",
          "label": "Tanzania, United Republic of"
      },
      {
          "id": "TH",
          "label": "Thailand"
      },
      {
          "id": "TL",
          "label": "Timor-Leste"
      },
      {
          "id": "TG",
          "label": "Togo"
      },
      {
          "id": "TK",
          "label": "Tokelau"
      },
      {
          "id": "TO",
          "label": "Tonga"
      },
      {
          "id": "TT",
          "label": "Trinidad and Tobago"
      },
      {
          "id": "TN",
          "label": "Tunisia"
      },
      {
          "id": "TR",
          "label": "Turkey"
      },
      {
          "id": "TM",
          "label": "Turkmenistan"
      },
      {
          "id": "TC",
          "label": "Turks and Caicos Islands"
      },
      {
          "id": "TV",
          "label": "Tuvalu"
      },
      {
          "id": "UG",
          "label": "Uganda"
      },
      {
          "id": "UA",
          "label": "Ukraine"
      },
      {
          "id": "AE",
          "label": "United Arab Emirates"
      },
      {
          "id": "GB",
          "label": "United Kingdom"
      },
      {
          "id": "US",
          "label": "United States"
      },
      {
          "id": "UM",
          "label": "United States Minor Outlying Islands"
      },
      {
          "id": "UY",
          "label": "Uruguay"
      },
      {
          "id": "UZ",
          "label": "Uzbekistan"
      },
      {
          "id": "VU",
          "label": "Vanuatu"
      },
      {
          "id": "VE",
          "label": "Venezuela"
      },
      {
          "id": "VN",
          "label": "Viet Nam"
      },
      {
          "id": "VG",
          "label": "Virgin Islands, British"
      },
      {
          "id": "VI",
          "label": "Virgin Islands, U.S."
      },
      {
          "id": "WF",
          "label": "Wallis and Futuna"
      },
      {
          "id": "EH",
          "label": "Western Sahara"
      },
      {
          "id": "YE",
          "label": "Yemen"
      },
      {
          "id": "ZM",
          "label": "Zambia"
      },
      {
          "id": "ZW",
          "label": "Zimbabwe"
      }
  ],
    singlifeBankNumber: "003-958595-0",
    singlifePayeeAccount: "Singapore Life Ltd.",
  },
  amountRangeSlider: {
    maximumAmountRange: -1,
    minimumAmountRange: -1,
  },
  transactionId: null,
  singpassInitiatedOrManual: null,
  quotation: {
    investingAmount: -1,
    sqsquotation: {
      deathBenefit: -1,
      maturityPayout: -1,
      surrenderValue: -1,
      surrenderValueList: [],
    },
  },
  AgreedInitialTerms: null,
  TrenchesLimit: false,
  PlanData: null,
};

const step1Slice = createSlice({
  name: "Ever_Green_Step_1",
  initialState,
  reducers: {
    updateAmountRange: (state, action: PayloadAction<IAmountRange>) => {
      state.amountRangeSlider = action.payload;
    },
    updateTransactionId: (state, action: PayloadAction<string>) => {
      state.transactionId = action.payload;
    },
    updateSqsQuotation: (state, action: PayloadAction<ISqsquotation>) => {
      state.quotation.sqsquotation = action.payload;
    },
    updateInvestAmount: (state, action: PayloadAction<number>) => {
      state.quotation.investingAmount = action.payload;
    },
    updateAgreedInitialTerms: (state, action: PayloadAction<boolean>) => {
      state.AgreedInitialTerms = action.payload;
    },
    updataStaticData: (state, action: PayloadAction<IStaticData>) => {
      state.staticData = action.payload;
    },
    updatePlanData: (state, action: PayloadAction<IPlanData>) => {
      state.PlanData = action.payload;
    },
    updateTrenchesLimit: (state, action: PayloadAction<boolean>) => {
      state.TrenchesLimit = action.payload;
    },
    updateSingpassInitiatedOrManual: (state, action: PayloadAction<"SINGPASS"|"MANUAL"|null>)=>{
      state.singpassInitiatedOrManual = action.payload
    },
    updateStep1ToDefault: (state,action)=>({
      ...initialState
    }),
    updateCountryList: (state, action: PayloadAction<Array<{id:string, label:string}>>)=>{
      state.staticData.countryList = action.payload
    }
  },
});

export const {
  updateAmountRange,
  updatePlanData,
  updateTransactionId,
  updateSqsQuotation,
  updateInvestAmount,
  updateAgreedInitialTerms,
  updataStaticData,
  updateTrenchesLimit,
  updateSingpassInitiatedOrManual,
  updateStep1ToDefault,
  updateCountryList
} = step1Slice.actions;

export default step1Slice.reducer;
